import { Component, OnInit,ChangeDetectorRef,ViewChild,ElementRef ,TemplateRef,Renderer2  } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { menulist }  from '../class/status';
import { page } from '../class/status';
import { Dep } from '../class/auth';
import * as moment from 'moment';
import * as Highcharts from 'highcharts';
import { Options } from "highcharts";
import { ToastComponent } from "../../layout/toast/toast.component";
import { windowTime } from 'rxjs/operators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'; // 引入 NgbModal

@Component({
    selector: 'app-adminreview',
    templateUrl: './adminreview.component.html',
    styleUrls: ['./adminreview.component.css']
})
export class AdminreviewComponent implements OnInit {

    @ViewChild('yourModalContent', { read: TemplateRef }) yourModalContent: TemplateRef<any>;
    @ViewChild(ToastComponent, { static: true }) toastComponent: ToastComponent;

    constructor(
        public httpClient: HttpClient,private modalService: NgbModal,private renderer: Renderer2
    ){}

    ngOnInit(): void {
        const arr = [3,5,6,13,14];
        let now = '0';
        if(arr.indexOf(Dep.auth.power_id*1)!=-1 ){
            now = '1';
        }
        // 日曆元件初始化與 schedules 首次載入各會 emit 一次當月 dateChange，
        // 先把 DateChange 設為當月，讓 onDateChange 的同月守門擋掉這些初始 emit（原本一進頁打 3 次 API）
        const today = new Date();
        this.DateChange = today.getFullYear() + '-' + String(today.getMonth() + 1).padStart(2, '0');
        this.choose(now);
        this.schedules = [];
        this.loginEmployeePowerID = Dep.auth.power_id;
    }

    review_show_data_key:any='0';
    ntype:any='0';
    schedules: any;
    sort_obj:any = {column:'create_dt',sort:'0'}
    loading:boolean=true;
    now:string='0';
    tool_obj:any={search_model:'',action:'0',action_type:'0',status:'0',patch_data:[],patch_status:'0',patch_memo:'',used_patch:0};
    menu_list:menulist = [
        {id:'0',name:'申請紀錄'},
        {id:'1',name:'審核申請'},
        {id:'2',name:'申請與通過比例'},
    ]
    patch_status_list:menulist = [
        {id:'-1',name:'拒絕'},
        {id:'1',name:'同意'},
        {id:'0',name:'待審'},
    ]
    status_list:menulist = [
        {id:'-2',name:'取消'},
        {id:'-1',name:'拒絕'},
        {id:'0',name:'待審'},
        {id:'1',name:'通過'},
    ]
    pageobj:page = {page:0,count:8,total_count:0};
    pageobjstr:string=JSON.parse(JSON.stringify(this.pageobj));
    time:any={'start':'','end':''};
    timeset = [{ type:1 , name: "過去7天", num: -7 }, { type:1 , name: "昨天", num: -1 },{ type:2 , name: "上個月", num: -1 }, { type:2 , name: "上上個月", num: -2 }];
    dimomenttimeset = [{ type:2 , name: "過去一個月", num: -1 },{ type:2 , name: "上上個月", num: -2 },{ type:4 , name: "近二個月", num: -2 },{ type:4 , name: "近三個月", num: -3 },{ type:4 , name: "近四個月", num: -4 },{ type:4 , name: "近五個月", num: -5 },{ type:4 , name: "近六個月", num: -6 }];
    limitset = [];
    top_data = [];
    data :any=[];
    review_show_data :any=-1//show該筆資料
    act_type = 2;
    detialdata :any=[];
    DateChange: any = '';
    tcontent = [
        {title:'審核項目',content:'mission_name'},
        {title:'預覽',content:'view',type:3},
        {title:'申請人',content:'emp_name'},
        {title:'狀態',content:'status_name'},
        {title:'審核時間',content:'update_dt'},
        {title:'操作',content:'gg',type:3},
    ];

    tcontent2 = [
        {title:'審核項目',content:'type'},
        {title:'預覽',content:'content',type:3},
        {title:'申請人',content:'emp_name'},
        {title:'預計發佈時間',content:'date',type:3},
        {title:'狀態',content:'lsstatus',type:3},
        {title:'操作',content:'gg',type:3},
    ];
    detail_status = '0';
    detail_list:menulist = [
        {id:'0',name:'時間'},
        {id:'1',name:'狀態'},
    ]

//-----------------

    generateReport = 0; //用這個來判斷是否是觀察申請與通過頁面。
    employeeData: any[] = []; // 申請與通過比例的資料
    empList: any[] = []; // 用於下拉選單的申請者清單
    selectedEmp: string = '-1'; // 預設選擇值（-1 代表全部）
    listSettingStatus: boolean = false;
    adminReview_time :any = {start:'',end:''};
    Highcharts: typeof Highcharts = Highcharts;  // 讓 HTML 能夠存取 Highcharts
    updateFlag: boolean = false; // 用來更新圖表
    pieOptions: Highcharts.Options; // 圓餅圖的設定
    pieStatusOptions: Highcharts.Options; // 第二個圓餅圖的選項
    loginEmployeePowerID: string = '-1';
    reviewtcontent = [
        { title: '🏷️員工名稱', content: 'name', type: 2}, // 員工名稱
        // { title: '員工編號', content: 'id'}, // 員工 ID
        { title: '®️總申請件數', content: 'totalcount' }, // 總申請件數
        { title: '❌取消件數', content: '-2' }, // 取消件數
        { title: '⛔拒絕件數', content: '-1' }, // 拒絕件數
        { title: '🈸待審件數', content: '0' }, // 待審件數
        { title: '✅通過件數', content: '1' }, // 通過件數
        { title: '✔️暫時通過件數', content: '2' }, // 暫時通過件數
        { title: '❌取消占比', content: 'cancelRate' }, // 取消占比
        { title: '⛔拒絕占比', content: 'rejectRate' }, // 拒絕占比
        { title: '🈸待審占比', content: 'pendingRate' }, // 待審占比
        { title: '✅通過占比', content: 'approveRate' }, // 通過占比
        { title: '✔️暫時通過占比', content: 'tempApproveRate' } // 暫時通過占比
    ];

    reviewtitle = [
        { title: '員工名稱' },
        // { title: '員工編號' },
        { title: '總申請件數' },
        { title: '取消件數' },
        { title: '拒絕件數' },
        { title: '待審件數' },
        { title: '通過件數' },
        { title: '暫時通過件數' },
        { title: '取消占比' },
        { title: '拒絕占比' },
        { title: '待審占比' },
        { title: '通過占比' },
        { title: '暫時通過占比' }
    ];

    reviewcontent = [
        { title: 'name', type: 2 }, // 員工名稱
        // { title: 'id' }, // 員工 ID
        { title: 'totalcount' }, // 總申請件數
        { title: '-2' }, // 取消件數
        { title: '-1' }, // 拒絕件數
        { title: '0' }, // 待審件數
        { title: '1' }, // 通過件數
        { title: '2' }, // 暫時通過件數
        { title: 'cancelRate' }, // 取消占比
        { title: 'rejectRate' }, // 拒絕占比
        { title: 'pendingRate' }, // 待審占比
        { title: 'approveRate' }, // 通過占比
        { title: 'tempApproveRate' } // 暫時通過占比
    ];

    // 是否顯示金額輸入
    showLockInput = false;
    // 上鎖金額
    lockAmount: number | null = null;
    lockAmount_btn = 0;
    toggleLockInput(): void {
        this.showLockInput = !this.showLockInput;
        // 如果關掉順便清空金額（看你需求，可拿掉）
        if (!this.showLockInput) {
            this.lockAmount = null;
        }
    }

    // 產生圓餅圖資料
    // 產生圓餅圖資料
    loadPieChart(): void {
        if (!this.employeeData || this.employeeData.length === 0) {
            this.pieOptions = {
                chart: { type: 'pie' },
                title: { text: '無數據' },
                series: [{
                    type: 'pie',
                    name: '申請數',
                    data: [] // 空數據
                }]
            };
            this.pieStatusOptions = this.pieOptions; // 讓第二張圖也顯示 "無數據"
            this.updateFlag = true; // 更新圖表
            return;
        }
        let data = [];
        let statusData = [];
        if(this.loginEmployeePowerID == "15"){ //這裡如果是員工權限為15的則重新指定
            this.selectedEmp = this.empList[0].id;
        }
        if (this.selectedEmp === '-1') {
            /** ✅ 1️⃣ 第一個圖表：顯示各員工申請件數比例 */
            data = this.employeeData.map(emp => ({
                name: emp.name,
                y: emp.totalcount
            }));

            /** ✅ 2️⃣ 第二個圖表：計算所有人的「通過、待審、取消、拒絕、暫時通過」比例 */
            let totalCancel = 0, totalReject = 0, totalPending = 0, totalApprove = 0, totalTempApprove = 0;
            this.employeeData.forEach(emp => {
                totalCancel += emp["-2"];
                totalReject += emp["-1"];
                totalPending += emp["0"];
                totalApprove += emp["1"];
                totalTempApprove += emp["2"];
            });

            statusData = [
                { name: "取消", y: totalCancel, color: "#E57373" }, // 柔和的紅色
                { name: "拒絕", y: totalReject, color: "#D32F2F" }, // 深紅色
                { name: "待審", y: totalPending, color: "#A8A8A8" }, // 中性灰色
                { name: "通過", y: totalApprove, color: "#43A047" }, // 柔和的綠色
                { name: "暫時通過", y: totalTempApprove, color: "#4DB6AC" } // 藍綠色
            ];
        } else {
            /** ✅ 3️⃣ 單一員工的申請狀況 */
            let emp = this.employeeData.find(e => e.id == this.selectedEmp);
            if (emp) {
                data = [
                    { name: "取消", y: emp["-2"], color: "#E57373" },
                    { name: "拒絕", y: emp["-1"], color: "#D32F2F" },
                    { name: "待審", y: emp["0"], color: "#A8A8A8" },
                    { name: "通過", y: emp["1"], color: "#43A047" },
                    { name: "暫時通過", y: emp["2"], color: "#4DB6AC" }
                ];
            }
        }

        /** ✅ 更新第一張圖表 */
        this.pieOptions = {
            chart: { type: 'pie' },
            title: { text: this.selectedEmp === '-1' ? '所有人申請件數比例' : '個人申請與通過比例' },
            tooltip: { pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>' },
            accessibility: { point: { valueSuffix: '%' } },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: true,
                        format: '<b>{point.name}</b>: {point.percentage:.1f} %'
                    }
                }
            },
            series: [{
                type: 'pie',
                name: '申請數',
                data: data
            }]
        };

        /** ✅ 更新第二張圖表（只有在 selectedEmp === '-1' 時顯示） */
        if (this.selectedEmp === '-1') {
            this.pieStatusOptions = {
                chart: { type: 'pie' },
                title: { text: '所有人通過比例' },
                tooltip: { pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>' },
                accessibility: { point: { valueSuffix: '%' } },
                plotOptions: {
                    pie: {
                        allowPointSelect: true,
                        cursor: 'pointer',
                        dataLabels: {
                            enabled: true,
                            format: '<b>{point.name}</b>: {point.percentage:.1f} %'
                        }
                    }
                },
                series: [{
                    type: 'pie',
                    name: '總數',
                    data: statusData
                }]
            };
        }

        this.updateFlag = true; // 讓 Highcharts 更新圖表
    }

    sort_list(){
        if(this.detail_status == '0'){
            // 假設所有時間都是同一天的，這裡隨便選一個日期
            const baseDate = '2024-01-01';

            // 將時間轉換為 Date 物件
            function timeToDate(time: string): Date {
                return new Date(`${baseDate}T${time}:00`);
            }

            // 進行排序
            this.detialdata.data.data = this.detialdata.data.data.sort((x, y) => timeToDate(x.date).getTime() - timeToDate(y.date).getTime());
        }else{
            this.detialdata.data.data = this.detialdata.data.data.sort((x, y) => x.lsstatus - y.lsstatus);
        }
    }


    onDateChange($event: Date) {
        let date = $event;
        const dc = date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0');
        if(dc === this.DateChange){
            return; // 同月份的重複 emit（日曆初始化/schedules 首次載入）不重打
        }
        this.DateChange = dc;
        console.log('DateChange',this.DateChange);
        this.init_list();
    }

    onAddSchedule($event: any) {
        console.log('onAddSchedule',$event);
    }

    onViewAllSchedule($event: any) {
        this.ntype = 1;
        this.detialdata = $event;
        this.modalService.open(this.yourModalContent, { centered: true,size: 'lg' });

        window.setTimeout(()=>{
            this.sort_list();
        },700)
    }

    onViewSchedule($event: any) {
        console.log('onViewSchedule',$event);
    }

    onDeleteSchedule($event: any) {
        console.log('onDeleteSchedule',$event);
    }

    close(){
        this.ntype = 0;
    }

    closemadel(){
        if(this.ntype == 1){
            window.setTimeout(()=>{
                const body =  document.querySelector('.sidebar-mini');
                this.renderer.addClass(body, 'modal-open');
            },350)
        }
    }

    init_list(){
        //action_type 0 是讀取list
        this.loading = true;
        const body = {data:this.tool_obj,page: this.pageobj.page,count:this.pageobj.count,now_range:this.time,sort_obj:this.sort_obj,action_type:0,DateChange:this.DateChange};
        this.httpClient.post<any>("/customer_service/get_review_list.php",body).subscribe(res => {
            this.loading = false;
            if(res.status){
                this.data = res.data;
                this.pageobj.total_count = res.total_count;
                this.schedules = [];
                if(res.calendarData.length > 0){
                    let tmpcalData = [];
                    res.calendarData.forEach(element => {
                        let tmpschedules = {
                            date: new Date(),
                            data:[]
                        };

                        element.forEach(item => {
                            let date = new Date(item.expected_dt); // 將日期時間字串轉換為 Date 物件
                            let Y = date.getFullYear(); // 獲取年份
                            let M = date.getMonth() ; // 獲取月份（注意 JavaScript 中的月份是從 0 開始的，所以要加 1）
                            let D = date.getDate(); // 獲取日期
                            let h = date.getHours(); // 獲取時
                            let hPadded = h.toString().padStart(2, '0'); // 如果是個位數，前面加0
                            let m = date.getMinutes(); // 獲取分
                            let mPadded = m.toString().padStart(2, '0'); // 如果是個位數，前面加0
                            tmpschedules.date = new Date(Y,M,D);
                            let tepdatadetail = {
                                title: item.front_show_info.title+'--'+item.emp_name+' '+h+':'+m,
                                content: item.show_content,
                                type: item.front_show_info.title,
                                emp_name: item.emp_name,
                                date: hPadded+':'+mPadded,
                                show_type:item.show_type,
                                id:item.id,
                                front_show_info:item.front_show_info,
                                lsstatus:item.status,
                                memo:item.memo,
                            }
                            tmpschedules.data.push(tepdatadetail);
                        });
                        tmpcalData.push(tmpschedules);
                    });
                    this.schedules = tmpcalData;
                }
            }else{
                this.data = [];
                this.pageobj.total_count = 0;
            }
            this.pageobjstr=JSON.parse(JSON.stringify(this.pageobj))
        });


    }

    used_patch(){
        if(this.tool_obj.status!=0 || this.tool_obj.used_patch==0){
            this.top_data = [];
        }else{
            this.data.forEach((item:any) => {
                let itembox = {
                    id:item.id, selected: false,request_emp_id:item.request_emp_id
                }
                this.top_data.push(itembox);
            });
        }
    }

    handleClick(item){

        this.review_show_data_key = item.idx;
        this.review_show_data = item.val;
        if(item.val.memo != ''){
            let tmpmemo = JSON.parse(item.val.memo);
            this.review_show_data.msg = tmpmemo[0]?.msg;
        }

        //補上鎖鑽石
        this.lockAmount = 0;
        if (this.review_show_data.lock_dimon > 0) {
            this.lockAmount = this.review_show_data.lock_dimon;
        }

              //補上鎖鑽石
        this.lockAmount_btn = 0;
        if (this.review_show_data.lock_btn > 0) {
            this.lockAmount_btn = 1;
        }


        window.setTimeout(()=>{
            $("#ggwp1").click();
        },350)
    }

    checkLt(list){
        this.tool_obj.patch_data = [];
        for(let i in list){
            if(list[i].selected){
                this.tool_obj.patch_data.push(list[i].id);
            }
        }
        this.save(-1);
    }

    handleRangeSelected( value: any ): void {
        let  eventDate = value.event;
        this.time.start =  '';
        this.time.end =  '';
        if(eventDate.startDate){
            this.time.start =  moment(eventDate.startDate).format('YYYY-MM-DD')
            this.time.end =  moment(eventDate.endDate).format('YYYY-MM-DD')
        }
        this.init_list();
    }

    copyToClipboard(item) {
        var clipBoardElem = document.createElement("input");
        document.body.appendChild(clipBoardElem);
        clipBoardElem.value = item;
        clipBoardElem.select();
        var successfulCopy = document.execCommand('copy');
        alert('複製成功');
        document.body.removeChild(clipBoardElem)
    }

    choose(value: string){
        if(value == "2"){ //這裡如果是申請與通過比例就進入，與申請紀錄、審核申請分開。
            this.tool_obj.action = value;
            this.generateApprovalReport();
        }else{
            /*根據tab 設定UI變換 */
            const commonStatusList = [
                { id: '-1', name: '拒絕' },
                { id: '0', name: '待審' },
                { id: '1', name: '通過' },
            ];

            this.status_list = this.tool_obj.action === 0 ? [...commonStatusList, { id: '-2', name: '取消' }]: commonStatusList;
            const des = value=='0' ?  '申請紀錄' : '審核申請';
            this.tcontent = [
                {title:'審核項目',content:'mission_name'},
                {title:'預覽',content:'view',type:3},
                {title:'申請人',content:'emp_name'},
                {title:'狀態',content:'status_name'},
                {title:des,content:'update_dt'},
                {title:'開始時間',content:'start_dt',type:3},
            ];

            if(value=='0'){
                this.tcontent.push({title:'理由',content:'reason',type:3});
            }
            this.tcontent.push({title:'操作',content:'gg',type:3});

            /*還原批次預設 */
            this.tool_obj.memo = '';
            this.tool_obj.patch = [];
            this.tool_obj.patch_status = '0';
            this.tool_obj.action = value;
            this.init_list();
        }
    }

    adminReviewShowDatePickered(){
        this.adminReview_time.start =  '';
        this.adminReview_time.end =  '';
        this.generateApprovalReport();
    }

    adminReviewHandleRangeSelected( value: any ): void {
        let eventDate = value.event;
        // console.log(eventDate.startDate)
        this.adminReview_time.start =  '';
        this.adminReview_time.end =  '';

        if(eventDate.startDate){
            this.adminReview_time.start =  moment(eventDate.startDate).format('YYYY-MM-DD')
            this.adminReview_time.end =  moment(eventDate.endDate).format('YYYY-MM-DD')
        }else{
            this.adminReview_time.start =  '';
            this.adminReview_time.end =  '';
        }

        // console.log("adminReview_time: " + JSON.stringify(this.adminReview_time));

        this.generateApprovalReport();
    }

    generateApprovalReport(){ //這裡主要向後端請求通過與申請比例
        this.loading = true;
        this.generateReport = 1;
        const body = {
            generateReport: this.generateReport,
            watchEmployeeNumber: this.selectedEmp,
            time:this.adminReview_time,
        };
        console.log("body: " + JSON.stringify(body) );

        this.httpClient.post<any>("/customer_service/get_review_list.php", body).subscribe(res => {
            this.loading = false;
            if(res.status){
                if(!this.listSettingStatus){
                    this.empList = res.emp_list;
                    this.listSettingStatus = true;
                }
                // 1. 先初始化 structuredData
                const structuredData = this.empList.map(emp => ({
                    id: emp.id,  // 員工ID
                    name: emp.name || "未知",  // 員工姓名
                    "-2": 0,
                    "-1": 0,
                    "0": 0,
                    "1": 0,
                    "2": 0,
                    totalcount: 0,
                    cancelRate: "0%", // 取消占比
                    rejectRate: "0%", // 拒絕占比
                    pendingRate: "0%", // 待審占比
                    approveRate: "0%", // 通過占比
                    tempApproveRate: "0%" // 暫時通過占比
                }));

                // **2. 確保 res.result 至少是一個空陣列**
                const resultData = res.result == 0 ? [] : res.result;

                // 2. 遍歷 result，填入對應的統計數據
                resultData.forEach(item => {
                    // console.log("item: " + JSON.stringify(item));
                    const index = structuredData.findIndex(emp => emp.id == item.request_emp_id); // 找到對應的員工

                    if (index !== -1) {
                        structuredData[index][item.status] += parseInt(item.count, 10); // 更新 status 對應的 count
                        structuredData[index].totalcount += parseInt(item.count, 10);  // 更新 totalcount
                    }
                });

                // 3. 計算各類狀態的佔比
                structuredData.forEach(emp => {
                    if (emp.totalcount > 0) {
                        emp.cancelRate = ((emp["-2"] / emp.totalcount) * 100).toFixed(2) + "%";
                        emp.rejectRate = ((emp["-1"] / emp.totalcount) * 100).toFixed(2) + "%";
                        emp.pendingRate = ((emp["0"] / emp.totalcount) * 100).toFixed(2) + "%";
                        emp.approveRate = ((emp["1"] / emp.totalcount) * 100).toFixed(2) + "%";
                        emp.tempApproveRate = ((emp["2"] / emp.totalcount) * 100).toFixed(2) + "%";
                    }
                });

                // 4. 根據 selectedEmp 過濾結果
                this.employeeData = this.selectedEmp === '-1'
                    ? structuredData
                    : structuredData.filter(emp => emp.id == this.selectedEmp);

                // 更新圓餅圖
                this.loadPieChart();
            }else {
                this.employeeData = [];
                this.loadPieChart();
                alert("資料取得錯誤!");
            }
            this.generateReport = 0; //關閉防止其他額外請求
        });
    }

    handlesortdata( value: any ): void {
        this.sort_obj = value;
        this.init_list();
    }

    cancel(){
        if(this.ntype == 1){
            window.setTimeout(()=>{
                const body =  document.querySelector('.sidebar-mini');
                this.renderer.addClass(body, 'modal-open');
            },350)
        }
    }

    save(type){
        let send_para = {id:[],type:type,status:0,memo:''};//-1是批次
        if(type == -1){//批次
            send_para.id=this.tool_obj.patch_data;
            send_para.status=this.tool_obj.patch_status;
            send_para.memo=this.tool_obj.patch_memo;
        }else{//個別
            send_para.id = [this.review_show_data.id];
            send_para.memo = this.review_show_data.msg;
            send_para.status = this.review_show_data.status;
        }

        if(send_para.status == 0){//代表沒有更改狀態（仍為待審）
            this.toastComponent.showMessage('沒有選取狀態', 'error');
        }else{
            //action_type = 1 是批准或拒絕或取消
            this.loading = true;
            const body = {
                data:send_para,
                action_type:1,
                lockAmount: this.lockAmount
            };
            console.log("body: " + JSON.stringify(body));
            this.httpClient.post<any>("/customer_service/get_review_list.php",body).subscribe(res => {
                this.loading = false;
                this.init_list();
                window.setTimeout(()=>{
                    this.tool_obj.used_patch = 0;
                    this.used_patch();//更新勾選
                },450)
            });
        }

        if(this.ntype = 1){
            window.setTimeout(()=>{
                const body =  document.querySelector('.sidebar-mini');
                this.renderer.addClass(body, 'modal-open');
            },350)

            this.detialdata.data.data[this.review_show_data_key].lsstatus = this.review_show_data.status;
        }
    }

    callback(pageobj:page){
        if(JSON.stringify(this.pageobj)!=JSON.stringify(pageobj)){
            this.pageobj = pageobj;
            this.init_list();
        }
    }
}
